import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import ReactDOM from 'react-dom'

// Styles
import './index.scss'

// Actions
import {
  StopLockOrder
} from '../../../../../actions/orders'

// import Overlay from '../../../../../shared/components/Overlay'
import ActionMenu from '../../../../../shared/components/ActionMenu'
import { translation } from '../../../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../../../utils/auth'

class Circle extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showTxt: false
    }
    this.updateTime = null
    this.checkStartStop = this.checkStartStop.bind(this)
    // this.triggerClick = this.triggerClick.bind(this)
  }

  componentDidMount () {
    // this.setState({
    //   item: this.props.item
    // }, () => this.checkStartStop(this.props))
    this.checkStartStop(this.props)
  }

  componentDidUpdate () {
    this.checkStartStop(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.openStartStopId !== this.props.openStartStopId) {
      this.checkStartStop(nextProps)
    }
    // this.setState({
    //   item: nextProps.item
    // }, () => {

    //   this.checkStartStop(nextProps)
    // })

    // if (this.props.assign_open !== nextProps.assign_open) {
    //   if (!nextProps.assign_open) {
    //     this.refs.overlay.triggerOpen()
    //   }
    //   if (this.nextProps !== undefined && this.nextProps.checkForPopups !== undefined) this.nextProps.checkForPopups()
    // }
  }

  checkStartStop (props) {
    if (props.item !== undefined && props.openStartStopId === props.item.Id) {
      // if (this.startStop !== undefined) {

      // }
      if (typeof this.startStop.click === 'function') {
        this.startStop.click()
        this.props.hasOpendStatrStop()
      }
    }
  }

  getCircleImages () {
    let { item } = this.props
    let image = 'Timespent-'
    let colored = (item.ColoredParts < 0) ? 0 : item.ColoredParts
    let delayType = item.RemainingTimeDelay
    if (item.CompletedGain !== undefined && item.CompletedGain !== null) {
      colored = item.CompletedGain.ColoredParts
      delayType = item.CompletedGain.Delay
    }
    switch (delayType) {
      case 0:
        if (colored === 0) {
          image += 'Black-0'
        } else {
          image += 'Green-' + colored
        }
        break
      case 1:
        image += 'Yellow-8'
        break
      case 2:
        let coloredX = (colored < 8) ? colored : 8
        coloredX = (coloredX === 0) ? 8 : coloredX
        image += 'Red-' + coloredX
        break
    }
    let color = (item.IsStarted && image.indexOf('Black-0') === -1) ? '-White' : ''
    return image + color
  }

  getEmployeeName () {
    let { item } = this.props
    // Employee
    let employee = ''
    if (item.Employees && item.Employees.length !== 0) {
      employee = item.Employees[0].Initials
      if (item.Employees.length !== 1 && employee !== '') {
        employee += '+'
      }
    }
    // Names popup
    let namesPopup = ''
    if (item.Employees && item.Employees.length !== 0) {
      let names = []
      item.Employees.map((val) => {
        names.push(val.Name)
      })
      namesPopup = "<span class='hint--bottom' aria-label='" + names.join('&#xa;') + "'>" + employee + '</span>'
    }
    if (namesPopup !== '') {
      return (
        <span>
          <div dangerouslySetInnerHTML={{ __html: namesPopup }} />
        </span>
      )
    }
    // Return normal
    return <span className='workers_name'>{employee}</span>
  }

  renderCircle (opener) {
    let { item } = this.props
    if (typeof item.ColoredParts === 'undefined') {
      return (
        <div className='workers' />
      )
    }
    let image = this.getCircleImages(item)
    let EmployeeName = this.getEmployeeName()
    const onClick = e => {
      if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
      let onClick = (item.IsCurrentUserWorking) ? this.props.stopOrder : this.props.startOrder
      if (opener !== false) {
        onClick = opener
      }
      onClick(e)
    }
    return (
      <div className='time_circle hasCursor' onClick={onClick} ref={(c) => (this.startStop = c)}>
        <img src={'/images/icons/circle/' + image + '.png'} className='worker__image' />
        {EmployeeName}
      </div>
    )
  }

  // triggerClick () {
  //   if (this.props.auth.departmentType === 1) return null // BodyShop should not have this yet...

  //   let type = !this.props.assign_open
  //   this.props.openAssign(type)
  //   let { item } = this.props
  //   let element = document.getElementById('' + item.Id)

  //   if (type) {
  //     let bounding = element.getBoundingClientRect()
  //     let distance = (window.innerHeight - 190) - (bounding.top + bounding.height)
  //     if (distance < 0) {
  //       let app = document.getElementById('app')
  //       distance = distance * -1
  //       element.style.marginBottom = distance + 'px'
  //       distance += app.scrollTop
  //       app.scrollTop = distance
  //     }
  //   } else {
  //     element.style.marginBottom = '0px'
  //   }
  // }

  render () {
    let { item } = this.props

    // Stop icon
    const renderStopIcon = () => {
      const renderActionOpener = (opener) => {
        return this.renderCircle(opener)
      }
      const renderActionMenu = () => {
        return (
          <div className='poppedup'>
            <a data-action='stop'><img src='/images/icons/pause-sign-32x32.png' />{translation('440')}</a>
            <a data-action='complete'><img src='/images/icons/Chekmark-Black-32.png' />{translation('1732')}</a>
          </div>
        )
      }
      const handleClick = (el) => {
        // if (this.props.item.Id === 1060364) {
        // } else if (this.props.item === undefined || this.props.item === null) console.log('MISSING ITEM')

        switch (el.dataset.action) {
          case 'stop':
            this.props.stopOrder()
            break
          case 'complete':
            this.props.moveOrders({ OrderIds: [this.props.item.Id], UserId: 0, StepFrom: item.StepId, StepTo: null  /*  (item.StepId + 1) */, Comment: '', FilterSettings: {} })
            break
        }
      }
      const className = () => { return 'action__menu close__menu' }

      return (
        <ActionMenu className={className} item={this.props.item} handleClick={handleClick} renderActionOpener={renderActionOpener} renderActionMenu={renderActionMenu} noAriaLabel />
      )
    }

    // Icon with names in
    const renderIconWithNames = () => {
      const onClick = e => {
        if (this.props.item.NeedReferredApprove) return null
        if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
        this.props.startOrder(e)
      }
      return (
        <div className='time_circle hasCursor' onClick={onClick} ref={(c) => (this.startStop = c)}>
          <img src={'/images/icons/Ring-Black.png'} />
          {this.getEmployeeName()}
        </div>
      )
    }

    if (item.IsStopped) {
      let text = item.StoppedMessage
      if (item.StoppedMessage.length > 50) {
        const breakTextNicely = (text, limit) => {
          var parts = text.split(' ')
          var lines = []
          text = parts[0]
          parts.shift()
          while (parts.length > 0) {
            var newText = `${text} ${parts[0]}`
            if (newText.length > limit) {
              lines.push(`${text}\n`)
              text = parts[0]
            } else {
              text = newText
            }
            parts.shift()
          }
          lines.push(text)
          return lines.join('')
        }
        text = breakTextNicely(item.StoppedMessage, 50)
      }

      let message = translation(13501) + text
      if (item.StoppedMessage.length === 0) {
        message = message.replace(':', '')
      }

      const call = () => {
        if (this.props.IsCustomer === true) {
          if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
          this.setState({
            showTxt: !this.state.showTxt
          })
        } else {
          this.props.unlockOrder()
        }
      }

      const popup = () => {
        if (this.props.IsCustomer !== true || this.state.showTxt === false || item.StoppedMessage.length === 0) return null

        if (item.PriceApprovalToken !== null) {
          this.props.router.push('/priceapproval/' + item.PriceApprovalToken)
          return null
        }
        return (
          <div className='poppedup padding InfoPopup'>
            <label>{item.StoppedMessage}</label>
          </div>
        )
      }

      if (!hasSubscriptionPermission(this.props.auth, 20)) {
        return (
          <div className='overlay time_circle hint--top' aria-label={message}>
            <img src='/images/icons/Stop-31.png' className='icon' />
          </div>
        )
      }
      return (
        <div className='overlay time_circle hint--top' aria-label={message} onClick={call} ref={(c) => (this.startStop = c)}>
          <img src='/images/icons/Stop-31.png' className='icon hasCursor' />
          {popup()}
        </div>
      )
    }

    if (!hasSubscriptionPermission(this.props.auth, 20)) {
      return (
        <div className='time_circle'>
          <img src={'/images/icons/Ring-Black.png'} />
          {this.getEmployeeName()}
        </div>
      )
    }

    // New type
    if (this.props.type !== '111') {
      if (item.IsCurrentUserWorking) {
        return renderStopIcon()
      }
    }

    const onClickOrderStart = e => {
      if (this.props.item.NeedReferredApprove) return null
      if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
      this.props.startOrder(e)
    }

    // Step 1 & 7
    if (item.StepId === 1 || item.StepId === 7) {
      if (item.IsCurrentUserWorking) {
        return renderStopIcon()
      }
      if (item.IsCurrentUserAssigned) {
        return (
          <div className='time_circle hasCursor' onClick={onClickOrderStart} ref={(c) => (this.startStop = c)}>
            <img src={'/images/icons/Start-Black.png'} />
          </div>
        )
      } else {
        return renderIconWithNames()
      }
    }

    // Order has been started
    if (item.PreviouslyStarted) {
      return this.renderCircle(false)
    }

    // User is assigned
    if (item.IsCurrentUserAssigned) {
      return (
        <div className='time_circle hasCursor' onClick={onClickOrderStart} ref={(c) => (this.startStop = c)}>
          <img src={'/images/icons/Start-Black.png'} />
        </div>
      )
    }

    if (item.CompletedGain !== undefined && item.CompletedGain !== null) {
      let circleClass = 'time_circle '
      let hoverText = null
      if (item.CompletedGain.Text != null) {
        circleClass += 'hint--top'
        hoverText = translation(2070) + ': ' + item.CompletedGain.Text
      }
      return (
        <div className={circleClass} aria-label={hoverText}>
          <img src={'/images/icons/circle/' + this.getCircleImages() + '.png'} />
        </div>
      )
    }

    // Order has not been started
    return renderIconWithNames()
    // return <Overlay ref='overlay' dontHandleClick renderActionMenu={renderActionMenu} renderActionOpener={renderActionOpener}
    //   openClick={openClick}
    //   checkForPopups={this.props.checkForPopups} />
  }

}

Circle.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  StopLockOrder
})(Circle)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/Circle/index.js